import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store, select } from '@ngrx/store';
import * as vmsReducer from '../../../../lib/microapp-vms.reducer';
import * as logBookActions from '../../../../lib/logbook/store/microapp-vms-logbook.actions'
import { MicroappVmsVisitGroup } from '../../../../lib/model/microapp-vms-visit-group.model';
import { selectLogBookLoading, selectLogBookError } from '../../../../lib/logbook/store/microapp-vms-logbook-selectors';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'empusa-microapp-vms-delete-group-visit',
  templateUrl: './microapp-vms-delete-group-visit.component.html',
  styleUrls: ['./microapp-vms-delete-group-visit.component.css']
})
export class MicroappVmsDeleteGroupVisitComponent implements OnInit, OnDestroy {
  visitGroup: MicroappVmsVisitGroup;
  loading: boolean;
  loading$: Subscription;

  constructor(private store: Store<vmsReducer.MicroappVmsStates>,
    private dialogRef: MatDialogRef<any>,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) data) {
      this.visitGroup = data;
  }


  ngOnInit(): void {
  }

  deleteVisit() {
    this.store.dispatch(logBookActions.deleteVisitGroup({ group_id: this.visitGroup.group_id }));

    this.loading$ = this.store.select(selectLogBookLoading).subscribe(loading => {
      this.loading = loading;
    });

    let saving$ = this.store.pipe(select(selectLogBookLoading)).subscribe(isLoading => {
      if (!isLoading) {
        this.store.pipe(select(selectLogBookError)).subscribe(hayError => {
          this.dialogRef.close(hayError);
        });
        saving$.unsubscribe();
      }
    });

  }

  ngOnDestroy(): void {
    if (this.loading$)
      this.loading$.unsubscribe();
  }

}
